import React from 'react';
import { Link } from "react-router-dom";
import BaseClass from '../common/baseClass';
import { connect } from "react-redux";
import { changeFilter, changeDatalist, changeMutex } from "../../redux/actions";
import { statusBarSelector } from "../../redux/selectors";
import FilterTavole from 'components/FilterTavole/FilterTavole';

const common = require('../common/common');
const env = require("../../config.js").default;

class DistintaStatusBar extends BaseClass {
  updateModel() {
    if (this.state.renewMutex.modelli) {
      this.props.changeMutex("modelli", false);
      common.apiCall(env.BACKEND + "epc/get_products/", "GET", { zprod: this.state.filtersState.marca }, true).then((modelli) => {
        if (modelli.error === false) {
          this.props.changeDatalist("modelli", modelli);
        }
      })
    }
  }

  async componentWillMount(props) {
    const $ = window.$;
    this.updateStateWithStoreProps();
    if(this.state.renewMutex.modelli){
      this.props.changeMutex("modelli", false);
      common.apiCall(env.BACKEND + "epc/get_products/", "GET", {zprod: this.state.filtersState.marca}, true).then((modelli) => {
        if(modelli.error === false){
          this.props.changeDatalist("modelli", modelli);
        }
      })
    }
    if(this.state.renewMutex.tavole && this.state.filtersState.modello !== ""){
      this.props.changeMutex("tavole", false);
      common.apiCall(env.BACKEND + "epc/get_model_draws/", "GET", {zprod: this.state.filtersState.marca, cmoto: this.state.filtersState.modello, lang:common.getLanguage()}, true).then((tavole) =>{
        if(tavole.error === false){
          var tavoleRaggruppate = {};
					for (var i = 0;i<tavole.length; i++){
            if(Object.keys(tavoleRaggruppate).indexOf(tavole[i].DTTAV) <= -1)
            tavoleRaggruppate[tavole[i].DTTAV] = [];
          tavole[i].visibile = true;
          tavoleRaggruppate[tavole[i].DTTAV].push(tavole[i]);
        }
        $("#erroreApiTavola").fadeOut("fast");
        this.props.changeDatalist("tavole", tavoleRaggruppate);
        }
      })
    }
  }
  
  componentWillReceiveProps(nextProps){
    this.updateStateWithStoreProps(nextProps);
  }
  
  componentDidUpdate() {
    this.updateStateWithStoreProps();
    if(this.state.dataList.modelli.length == 0)
      this.updateModel();
  }


  render(){
    var nomeModello = "";
    var nomeGrTavola = "";
    var nomeTavola = "";

    var gruppi = Object.keys(this.state.dataList.tavole);
    if(this.state.renewMutex.mostraImg ){
      for (var i=0; i<this.state.dataList.modelli.length;  i++){
        if(this.state.dataList.modelli[i].CMOTO === this.state.filtersState.modello){
          nomeModello = this.state.dataList.modelli[i].DMOBA;
          break;
        }
      }

      for(var g=0; g<gruppi.length; g++){
        for(var j=0; j<this.state.dataList.tavole[gruppi[g]].length; j++){
          if(this.state.dataList.tavole[gruppi[g]][j].CTAVO === this.state.filtersState.tavola){
            nomeGrTavola = gruppi[g];
            nomeTavola = this.state.dataList.tavole[gruppi[g]][j].DTAVO;
            break;
          }
        }
        if(nomeGrTavola !== "")
          break;
      }
    }

    return(
      <div className="drawToolbar row">
        <div className="col-lg-2 col-md-3 col-sm-4 mb-3">
          <Link className="btn bottone_default homepage_nav" to="/"><i className="fas fa-chevron-left"></i> {common.getTrad("Indietro")}</Link>
        </div>
        <div className="col-lg-10 col-md-9 col-sm-8 row" style={{wordBreak: "break-word"}}>
          {this.state.filtersState.telaio !== "" ?
            <div className="col-lg-3 col-sm-6 mb-2 pl-0 drawToolbarTitles">
              <h5>{common.getTrad("Telaio cercato")}:</h5>
              <span>{this.state.filtersState.telaio}</span>
            </div>
          :
            ""
          }
          <div className={(this.state.filtersState.telaio !== "" ? "col-lg-3" : "col-lg-4") + " col-sm-6 mb-2 pl-0 drawToolbarTitles"}>
            <h5>{common.getTrad("Modello")}:</h5>
            <span>{nomeModello}</span>
          </div>
          <div className={(this.state.filtersState.telaio !== "" ? "col-lg-3" : "col-lg-4") + " col-sm-6 mb-2 pl-0 drawToolbarTitles"}>
            <h5>{common.getTrad("Gruppo Tavola")}:</h5>
            <span>{this.state.renewMutex.newUrl ? this.state.filtersState.distintaGruppo : nomeGrTavola}</span>
          </div>
          <div className={(this.state.filtersState.telaio !== "" ? "col-lg-3" : "col-lg-4") + " col-sm-6 mb-2 pl-0 drawToolbarTitles"}>
            <FilterTavole isBar={true}></FilterTavole>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const store = statusBarSelector(state);
  return { store };
}
export default connect(mapStateToProps, {changeFilter, changeDatalist, changeMutex})(DistintaStatusBar);
